import { Pipe, PipeTransform } from '@angular/core';
@Pipe({ name: 'ZipCodeFilter'})
export class ZipCodeFilter implements PipeTransform {
  transform(value: string): string {
    if (value === undefined || value === null || value === '') {
      return '';
    } else {
      return (value.includes('-') || value.length < 4) ? '〒' + value : '〒' + value.substr(0, 3) + '-' + value.substr(3);
    }      
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/pipes/zipcode.pipe.ts